import { DeliveryQuote } from '@onepercentio/rarum-types/logistics'
import { AssetType, Sale } from 'core/logic/asset/asset.types'
import { Address } from 'features/Form/AddressForm/AddressForm.types'
import { PropsWithChildren } from 'react'

export enum DigitalTwinBuyStep {
  DELIVERY_ADDRESS,
  DELIVERY_METHOD,
  PAYMENT_METHOD,
}
export type DigitalTwinProps = {
  asset: AssetType
  sale: Sale
  onBuyOffer(deliveryAddress: Address, quote: DeliveryQuote): void
}
export type DigitalTwinViewProps = PropsWithChildren<{
  currentStep: DigitalTwinBuyStep
  // canContinue: boolean
  // continueLabel: string
}>
//  & ClickActions<'onContinue'>
